import { render, staticRenderFns } from "./ShowResult.vue?vue&type=template&id=a90c5ba2&scoped=true&"
import script from "./ShowResult.vue?vue&type=script&lang=js&"
export * from "./ShowResult.vue?vue&type=script&lang=js&"
import style0 from "./ShowResult.vue?vue&type=style&index=0&id=a90c5ba2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a90c5ba2",
  null
  
)

export default component.exports